import {ALERT_SET_ID} from '../actions/types';

const INITIAL_STATE = {
  id: '',
  modalProps: {},
};

const AlertReducer = (
  state = INITIAL_STATE,
  action: {type: String; payload: any},
) => {
  switch (action.type) {
    case ALERT_SET_ID:
      return {
        ...state,
        ...action?.payload,
      };
    default:
      return state;
  }
};

export default AlertReducer;
